import { Layer, Source } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import {
  RISK_ZONES_LAYER_STYLE,
  RISK_ZONES_NAME_LAYER_STYLE,
  RISK_ZONES_OUTLINE_LAYER_STYLE,
} from '../../../constants/map';
import { selectedZoneFenceState, zoneFencesGeojsonState } from '../../../storage/map';

export function ZoneFencesLayer() {
  const selectedZoneFenceLayer = useRecoilValue(selectedZoneFenceState);
  const zoneFencesGeojson = useRecoilValue(zoneFencesGeojsonState);

  if (!selectedZoneFenceLayer || !zoneFencesGeojson) return null;

  const geojson = zoneFencesGeojson[selectedZoneFenceLayer];

  if (!geojson) return null;

  return (
    <Source
      type="geojson"
      data={geojson}
      id="zone-fences"
    >
      {/* TODO: Make styles for each zone if required. */}
      <Layer {...RISK_ZONES_LAYER_STYLE} />
      <Layer {...RISK_ZONES_OUTLINE_LAYER_STYLE} />
      <Layer {...RISK_ZONES_NAME_LAYER_STYLE} />
    </Source>
  );
}
